(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aura-ring-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aura-ring-size-guide')) {
    customElements.define('aura-ring-size-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const initialize = () => {
          const dialog = this.querySelector('dialog');
          const trigger = this.querySelector('[data-size-guide-open]');
          const close = this.querySelector('[data-size-guide-close]');
          if (!dialog || !trigger || !close || !this.isConnected) return;
          trigger.addEventListener('click', () => { if (!dialog.open) dialog.showModal(); }, options);
          close.addEventListener('click', () => dialog.close(), options);
          dialog.addEventListener('click', event => {
            const box = dialog.getBoundingClientRect();
            if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
          }, options);
          trigger.disabled = false;
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { ...options, once: true });
        else initialize();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
